import { useRouter } from "next/router";
import { useEffect } from "react";
import { chunk } from "util/helper/chunk";
import { loadCategoryMapLocale } from "../../util/helper/loadCategoryMapLocale";
import CategoryItem from "./CategoryItem";
import styles from "./renderSubCategoriesContainer.module.scss";

function RenderSubCategoriesContainer(props: any) {
  const {
    t0, sub, subname, onTierClick, isLocaleLoaded, onT0Click, onUnmount, closeToolbar,
    isRegularService, className,
  } = props;

  const filteredSubs = sub.filter((tier: any) => !tier.hide);

  const router = useRouter();
  const { locale } = router;

  useEffect(() => {
    loadCategoryMapLocale(locale, isLocaleLoaded, onT0Click);

    return () => {
      onUnmount();
    };
  }, []);

  // 4 on tablet and 6 on desktop.

  function RenderCategoryItem({ categoryItemProps, big_icon }) {
    const { view } = categoryItemProps.subCategory;
    return (
      <div
        key={subname}
        className={`text-center ${styles.category_container} ${big_icon ? styles.big_icon : styles.small_icon} ${view === "list" ? styles.list_view : ""} `}
      >

        <CategoryItem {...categoryItemProps} isRegularService={isRegularService} onTierClick={onTierClick} closeToolbar={closeToolbar} big_icon={big_icon} />
      </div>
    );
  }
  const eachColumnSize = Math.ceil(filteredSubs.length / 3);
  const chunks = chunk(filteredSubs, eachColumnSize);

  return (
    <div className={`${styles.sub_container} d-flex`}>
      {chunks.map((subChunks: any, idx: number) => (

        <div key={idx} className={className}>
          {subChunks.map((subCategory: any, index: any) => {
            const categoryItemProps = {
              t0: t0 || subCategory.t0,
              subCategory,
              index: (idx * eachColumnSize) + index,
            };
            const big_icon = subCategory.isPopular;

            return (

              <RenderCategoryItem key={index} big_icon={big_icon} categoryItemProps={categoryItemProps} />

            );
          })}
        </div>
      ))}
    </div>
  );
}

export default RenderSubCategoriesContainer;
